function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#608ef5;}.b{fill:#fff;}.c{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  x: 0,
  y: 0,
  width: 48,
  height: 48,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "b"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.149
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "b"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-510 -298)"
}, /*#__PURE__*/React.createElement("g", {
  className: "c",
  transform: "matrix(1, 0, 0, 1, 510, 298)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "a",
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(9 6)"
})), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M434.56,418.332v12.875l4.985,5.712a.345.345,0,0,0,.6-.227v-7.281a.252.252,0,0,0-.13-.224,1.922,1.922,0,1,1,1.8,0,.254.254,0,0,0-.133.225v7.283a.345.345,0,0,0,.6.227l4.985-5.712V418.332a.172.172,0,0,0-.172-.173H434.732A.173.173,0,0,0,434.56,418.332Z",
  transform: "translate(93.392 -107.913)"
}));

var SvgPen = function SvgPen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pen.a3bff28a.svg";
export { ForwardRef as ReactComponent };